<template>
  <base-layout manualRedirect @go-back="goBack">
    <v-container class="password-recover" fluid>
      <v-row no-gutters>
        <v-col>
          <p class="password-recover-title" :style="{ color: getAssets.colors.form.buttonBackground }">Você já faz parte do clube!</p>
          <p class="password-recover-subtitle">
            Para criarmos uma nova senha precisamos confirmar este dado: <span class="password-recover-break"> Digite seu endereço de e-mail completo. </span>
          </p>
          <p class="password-recover-email">{{ hiddenEmail }}</p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-text-field :value="formattedCpfCnpj" outlined hide-details label="CPF/CNPJ" class="mb-5" disabled />
      </v-row>
      <v-row no-gutters>
        <v-text-field
          v-model="emailConfirm"
          outlined
          label="Confirme seu e-mail"
          class="mb-5"
          :error-messages="emailConfirmError"
          type="text"
          @input="emailConfirmError = ''"
        />
      </v-row>
      <v-row class="mb-3" no-gutters>
        <v-btn
          width="100%"
          class="button-height"
          :color="getAssets.colors.form.buttonBackground"
          :style="{ color: getAssets.colors.form.buttonFont }"
          :loading="btnLoading"
          :disabled="!emailConfirm"
          @click="submit"
          >enviar senha</v-btn
        >
      </v-row>
      <v-row no-gutters>
        <span class="link" @click="handleNotMyEmail">Este não é o meu e-mail</span>
      </v-row>
    </v-container>
  </base-layout>
</template>

<script>
import { documentMaskMixin } from '@/mixins/document-mask'
import { sanitizeCnpj } from '@/helpers/cnpj'
import { formatCpfOrCnpj } from '@/helpers/cpfCnpj'

export default {
  components: {
    BaseLayout: () => import('@/components/layout/BaseLayout.vue')
  },
  mixins: [documentMaskMixin],
  data: () => ({
    label: '',
    cpfCnpj: '',
    emailConfirm: '',
    emailConfirmError: '',
    btnLoading: false
  }),
  computed: {
    hiddenEmail() {
      return this.$store.getters.HIDDEN_EMAIL
    },
    getAssets() {
      return this.$store.getters.GET_ASSETS
    },
    hasSms() {
      return this.$store.getters.HIDDEN_PHONE && this.$store.getters.SMS_CHANNEL
    },
    unmaskedDocument() {
      return sanitizeCnpj(this.cpfCnpj)
    },
    formattedCpfCnpj() {
      return formatCpfOrCnpj(this.cpfCnpj)
    }
  },
  created() {
    const query = Object.entries(this.$route.query)
    this.cpfCnpj = query[0][1]
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'cliente-cadastrado', query: { [this.label]: this.cpfCnpj }, params: { fromRecover: true } })
    },
    submit() {
      if (!this.emailConfirm) {
        this.emailConfirmError = 'Este campo é obrigatório.'
        return
      }
      this.btnLoading = true
      this.$store
        .dispatch('recoverPassword', {
          email: this.emailConfirm,
          url: `${document.location.origin}`
        })
        .then(() => {
          this.$store.commit('USER_EMAIL', this.emailConfirm)
          this.$router.push({ path: '/email-enviado' })
        })
        .catch(err => {
          if (err.response && err.response.errors && err.response.errors[0] && err.response.errors[0].message === 'email.not.registered') {
            this.emailConfirmError = 'E-mail incorreto'
            return
          }
          this.$snackbar({
            message: 'Ocorreu um erro. Tente novamente mais tarde',
            snackbarColor: 'error'
          })
          console.error(err)
        })
        .finally(() => {
          this.btnLoading = false
        })
    },
    redirect(route, value) {
      const cpfCnpj = value.length === 11 ? 'cpf' : 'cnpj'
      this.$router.push({
        path: route,
        query: { [cpfCnpj]: value }
      })
    },
    handleNotMyEmail() {
      if (this.hasSms) this.redirect('recuperar-senha-sms', this.unmaskedDocument)
      else this.$router.push({ path: '/contato' })
    }
  }
}
</script>

<style lang="scss">
$phone-size: 600px;
$tablet-size: 960px;

.password-recover {
  padding: 40px 30px !important;
  text-align: center;

  &-title {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 17px;
  }

  &-subtitle {
    font-size: 14px;
    color: #6b7580;
  }

  &-email {
    font-weight: 700;
  }

  .link {
    margin: auto;
    font-size: 14px;
    color: #0079f2;
    cursor: pointer;
  }

  .link:hover {
    text-decoration: underline;
  }
}

@media screen and (min-width: $phone-size) {
  .password-recover {
    text-align: left;

    &-title {
      font-size: 32px;
      margin-bottom: 8px !important;
    }

    &-subtitle {
      margin: 0 0 21px !important;
    }

    &-email {
      font-size: 24px;
      margin-bottom: 8px;
      word-break: break-all;
    }

    &-break {
      display: block;
    }
  }
}
</style>
